function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "V2---Videos-and-images-template",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "03.7c_V2---Videos-and-images-template",
  transform: "translate(-17.000000, -238.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "content",
  transform: "translate(8.000000, 227.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image-hover"
}, /*#__PURE__*/React.createElement("g", {
  id: "Looks-edit-bar"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-media"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/image",
  transform: "translate(9.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.384162,5.10987097 C11.1270969,5.10987097 11.7313989,4.53270968 11.7313989,3.82335484 C11.7313989,3.11380645 11.1270969,2.53683871 10.384162,2.53683871 C9.64102564,2.53683871 9.03652209,3.11380645 9.03652209,3.82335484 C9.03652209,4.53270968 9.64102564,5.10987097 10.384162,5.10987097 L10.384162,5.10987097 Z M14.0275049,10.3157419 L14.0275049,8.78225806 L12.8019747,7.66219355 L11.144023,9.09445161 C10.8526523,9.33232258 10.4444109,9.32767742 10.1582792,9.08419355 L5.9229258,5.53412903 L1.7534633,8.79251613 L1.7534633,10.3157419 L14.0275049,10.3157419 Z M1.7534633,1.68406452 L1.7534633,6.87948387 L5.45806257,3.9963871 C5.74963478,3.76412903 6.21107249,3.77148387 6.49418165,4.01283871 L10.6648532,7.55709677 L12.4060249,6.13219355 C12.6929626,5.89780645 13.0105284,5.89819355 13.2972646,6.13374194 L14.0275049,6.84251613 L14.0275049,1.68406452 L1.7534633,1.68406452 Z M16,11.157871 C16,11.6229677 15.6074757,12 15.1232683,12 L0.876731651,12 C0.392524306,12 0,11.6229677 0,11.157871 L0,0.842129032 C0,0.37683871 0.392524306,0 0.876731651,0 L15.1232683,0 C15.6074757,0 16,0.37683871 16,0.842129032 L16,11.157871 Z",
  id: "Fill-8"
}))))))));

function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.2c55bbf7.svg";
export { ForwardRef as ReactComponent };